
import toast from 'react-hot-toast';
export function toastAlert(errorType, message, id, 
    position = 'top-right' //TOP_RIGHT, TOP_CENTER
) {

    if (errorType === 'error') {
        toast.error(message, {
            position
        })
    } else if (errorType === 'success') {
        toast.success(message, {
            position
        })
       
    } else if (errorType === 'update') {
        toast.loading(message, {
            position
        })
    }
}